import { useCallback } from 'react';
import { useAsyncCallback } from '@react-hooks-library/core';
import { getSoilTable } from '@utils/getSoilTable';

export const useGetSoilTable = () => useAsyncCallback(useCallback(async (boundaryTableGuid: string) => await getSoilTable(boundaryTableGuid), []));
